import React from "react";
import BaseCard from "src/app/components/commonComponents/BaseCard";
import ObservationCardInternalDetails from "src/app/components/ObservationCardInternalDetails";
import { Observation } from "src/shared/types/src";

const ObservationCard = ({ details }: { details: Observation }) => {
    // onPressFunc = {() => navigate(AppRoutes.OBSERVATION_DETAILS_SCREEN(details?.id), { state: { observationDetails: details } })}
    return (
        <div className="mg-t-15">
            <BaseCard clickable={true}>
                <ObservationCardInternalDetails details={details} />
            </BaseCard>
        </div>
    )
}

export default ObservationCard;